// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"4":"049fb2e0","856":"f091f180"}[chunkId] + ".js";
};